export enum ModalEnum {
  congratulation = 'congratulation',
  submitSession = 'submitSession',
  rematchProvider = 'rematchProvider',
  noSession = 'noSession',
  cancelSession = 'cancelSession',
}

export const enum AvailabilitySettingsModalType {
  timezone = 'timezone',
  idealCaseload = 'idealCaseload',
  disconnectGoogleCalendar = 'disconnectGoogleCalendar',
  connectGoogleCalendar = 'connectGoogleCalendar',
}
